import patient from './patient';
import recommendations from './recommendations';
import userDetails from './userDetails';
import recipientDetails from './recipientDetails';
import questionnaire from './questionnaire';
import clinician from './clinician';
import token from './token';

export default {
  clinician, patient, recommendations, userDetails, recipientDetails, questionnaire, token,
};



// WEBPACK FOOTER //
// ./src/reducers/index.js